// general
import Antispam from '../../components/Antispam';

// project
import Navigation from './Navigation';
import FixedTopbar from './FixedTopbar';
import Carousel from "./Carousel";
import CookieBubble from '../../components/CookieBubble';
import Scroll from './Scroll';

const Components = {
    Antispam,
    CookieBubble,
    FixedTopbar,
    Carousel,
    Navigation,
    Scroll
};

export default Components;


// WEBPACK FOOTER //
// ./components/index.js